function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react'; // import GalleryItem from '../item/galleryItem';

import GALLERY_EVENTS from '../../../common/constants/events';
import GALLERY_SIZE_TYPE from '../../../common/constants/gallerySizeType';

var get = function get(item, attr) {
  if (typeof item[attr] !== 'undefined') {
    return item[attr];
  }

  if (typeof item.metadata !== 'undefined') {
    if (typeof item.metadata[attr] !== 'undefined') {
      return item.metadata[attr];
    }
  }

  if (typeof item.metaData !== 'undefined') {
    if (typeof item.metaData[attr] !== 'undefined') {
      return item.metaData[attr];
    }
  }
};

var LeanGallery =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(LeanGallery, _React$Component);

  function LeanGallery() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.measureIfNeeded = _this.measureIfNeeded.bind(_assertThisInitialized(_this));
    _this.state = {
      itemStyle: {}
    };
    return _this;
  }

  var _proto = LeanGallery.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.eventsListener(GALLERY_EVENTS.APP_LOADED, {});
  };

  _proto.resizeUrl = function resizeUrl(_ref) {
    var item = _ref.item;
    var _this$props = this.props,
        styles = _this$props.styles,
        resizeMediaUrl = _this$props.resizeMediaUrl;
    var cubeType = styles.cubeType,
        imageQuality = styles.imageQuality;
    var itemStyle = this.state.itemStyle;
    var url = item.url,
        mediaUrl = item.mediaUrl,
        src = item.src;
    var itemUrl = url || mediaUrl || src;
    var width = itemStyle.width || 250;
    var height = itemStyle.height || 250;
    var focalPoint = false;
    var isPreload = !(itemStyle.width > 0);
    var options = isPreload ? {
      quality: 30,
      blur: 30
    } : {
      quality: imageQuality
    };

    if (typeof resizeMediaUrl === 'function') {
      try {
        return resizeMediaUrl({
          maxWidth: get(item, 'width'),
          maxHeight: get(item, 'height')
        }, itemUrl, cubeType, width, height, options, false, focalPoint) || '';
      } catch (e) {
        return String(itemUrl);
      }
    } else {
      return String(itemUrl);
    }
  };

  _proto.calcItemSize = function calcItemSize() {
    var _this$props2 = this.props,
        styles = _this$props2.styles,
        container = _this$props2.container;
    var gallerySizeType = styles.gallerySizeType,
        gallerySize = styles.gallerySize,
        gallerySizePx = styles.gallerySizePx,
        gallerySizeRatio = styles.gallerySizeRatio;
    var itemSize;

    if (gallerySizeType === GALLERY_SIZE_TYPE.PIXELS && gallerySizePx > 0) {
      itemSize = gallerySizePx;
    } else if (gallerySizeType === GALLERY_SIZE_TYPE.RATIO && gallerySizeRatio > 0) {
      itemSize = container.width * (gallerySizeRatio / 100);
    } else {
      itemSize = Math.round(gallerySize * 8.5 + 150);
    }

    var minmaxFix = 0.75; //this fix is meant to compensate for the css grid ability to use the number as a minimum only (the pro-gallery is trying to get as close as possible to this number)

    itemSize *= minmaxFix;
    return Math.min(itemSize, container.width);
  };

  _proto.createGalleryStyle = function createGalleryStyle() {
    var styles = this.props.styles;
    var gridStyle = styles.gridStyle,
        numberOfImagesPerRow = styles.numberOfImagesPerRow,
        imageMargin = styles.imageMargin;
    var gridTemplateColumns = gridStyle === 1 ? "repeat(" + numberOfImagesPerRow + ", 1fr)" : "repeat(auto-fit, minmax(" + this.calcItemSize() + "px, 1fr))";
    return {
      display: 'grid',
      gridTemplateColumns: gridTemplateColumns,
      gridGap: imageMargin + "px"
    };
  };

  _proto.createItemStyle = function createItemStyle() {
    var styles = this.props.styles;
    var cubeType = styles.cubeType,
        borderWidth = styles.itemBorderWidth,
        borderColor = styles.itemBorderColor,
        borderRadius = styles.itemBorderRadius;
    return _objectSpread({}, this.state.itemStyle, {
      objectFit: cubeType === 'fit' ? 'contain' : 'cover',
      borderWidth: borderWidth,
      borderColor: borderColor,
      borderRadius: borderRadius
    });
  };

  _proto.measureIfNeeded = function measureIfNeeded(node) {
    var styles = this.props.styles;

    if (!this.node && node) {
      this.node = node;
    }

    if (this.node && this.node.clientWidth !== this.clientWidth) {
      this.clientWidth = this.node.clientWidth;
      this.setState({
        itemStyle: {
          width: this.clientWidth,
          height: Math.round(this.clientWidth / styles.cubeRatio)
        }
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.measureIfNeeded();
  };

  _proto.render = function render() {
    var _this2 = this;

    var items = this.props.items;
    return React.createElement("div", {
      style: this.createGalleryStyle()
    }, items.map(function (item) {
      return React.createElement("div", {
        style: {
          overflow: 'hidden',
          height: _this2.state.itemStyle.height
        },
        ref: _this2.measureIfNeeded
      }, React.createElement("img", {
        src: _this2.resizeUrl({
          item: item
        }),
        loading: "lazy",
        alt: get(item, 'title'),
        style: _this2.createItemStyle() // onClick={() => this.props.eventsListener(GALLERY_EVENTS.ITEM_ACTION_TRIGGERED, new GalleryItem({dto: item}))}

      }));
    }));
  };

  return LeanGallery;
}(React.Component);
/* 
todo: 
  itemClick
  links
  Events
  Texts
  auto render by styleParams
 */


export { LeanGallery as default };